import { contentfulImageLoader } from "@utils/imageLoader";
import { FC, useState } from "react";

import AnchorLink from "@/components/ui/AnchorLink/AnchorLink";
import { GuidedToolCardItemProps } from "@/types";

import GuidedToolModal from "./GuidedToolModal";
import { GuidedToolProvider } from "./GuidedToolProvider";

const GuidedToolCard: FC<GuidedToolCardItemProps> = ({ card }) => {
  const Wrapper = (card.modal ? "button" : AnchorLink) as keyof JSX.IntrinsicElements;
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const cardUrl = card.url || card.link?.link.url;

  return (
    <GuidedToolProvider modalOpen={modalOpen}>
      <Wrapper
        {...(cardUrl && { href: cardUrl })}
        {...(card.modal && { onClick: () => setModalOpen(true) })}
        className="rounded-lg overflow-hidden relative group"
      >
        <div className="relative">
          <img
            className="w-full transition transform hover:duration-[6000ms] group-hover:scale-105 motion-reduce:transition-none motion-reduce:hover:transform-none aspect-3-4 object-cover"
            src={contentfulImageLoader({ src: card.image.url, width: 400, quality: 80 })}
            srcSet={[300, 400, 600, 800].map((w) => `${contentfulImageLoader({ src: card.image.url, width: w, quality: 80 })} ${w}w`).join(", ")}
            sizes="(min-width: 1024px) calc((100vw * 20 / 24) / 4), calc((100vw * 22 / 24) / 2)"
            alt={card.image.title}
            loading="lazy"
            decoding="async"
          />
          <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-4"></div>
        </div>
        <p className="font-primary font-medium uppercase text-s md:text-l text-white absolute translate-y-[-50%] translate-x-[-50%] top-[50%] left-[50%] w-full text-center p-s">
          {card.title}
        </p>
      </Wrapper>
      {card.modal && <GuidedToolModal guidedTool={card.modal} modalOpen={modalOpen} closeModal={() => setModalOpen(false)} />}
    </GuidedToolProvider>
  );
};

export default GuidedToolCard;
